import Wallet from '@core/wallet/Wallet';

export default class BalanceService {

    async syncBalance(wallet: Wallet){
        let currencies = wallet.getEnabledCurrencies();
        return  Promise.all(currencies.map((currency) => currency.syncBalance()));
    }
}
